export default __webpack_public_path__ + "static/media/performance.0c976f53.svg";